"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOkta = void 0;

var _react = _interopRequireWildcard(require("react"));

var _oktaAuthJs = require("@okta/okta-auth-js");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var addTokens = function addTokens(tokenManager, tokens) {
  if (tokens.idToken) {
    tokenManager.add("idToken", tokens.idToken);
  }

  if (tokens.accessToken) {
    tokenManager.add("accessToken", tokens.accessToken);
  }
};

var handleLogin =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(authClient, onLogin, onError) {
    var tokenManager, accessToken, windowHash, _ref2, tokens, param, state, tokenParams;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenManager = authClient.tokenManager;
            _context.next = 3;
            return tokenManager.get("accessToken");

          case 3:
            accessToken = _context.sent;
            windowHash = window.location.hash;

            if (!accessToken) {
              _context.next = 9;
              break;
            }

            onLogin();
            _context.next = 30;
            break;

          case 9:
            if (!windowHash) {
              _context.next = 27;
              break;
            }

            _context.prev = 10;
            _context.next = 13;
            return authClient.token.parseFromUrl();

          case 13:
            _ref2 = _context.sent;
            tokens = _ref2.tokens;
            addTokens(tokenManager, tokens); // parse url

            param = _queryString["default"].parse(windowHash);
            state = decodeURIComponent(param.state);
            onLogin(state);
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](10);
            console.error(_context.t0);
            onError(_context.t0);

          case 25:
            _context.next = 30;
            break;

          case 27:
            tokenParams = {
              responseType: ["token", "id_token"],
              scopes: ["openid", "profile", "email", "groups"],
              expireEarlySeconds: 120,
              nonce: "uSeRInfo",
              pkce: false,
              state: encodeURIComponent(window.location.pathname + window.location.search)
            };
            _context.next = 30;
            return authClient.token.getWithRedirect(tokenParams);

          case 30:
            return _context.abrupt("return", Promise.resolve());

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 21]]);
  }));

  return function handleLogin(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var useOkta = function useOkta(config, onLogin, onError) {
  var _useState = (0, _react.useState)({
    loginFunction: function () {
      var _loginFunction = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function loginFunction() {
        return _loginFunction.apply(this, arguments);
      }

      return loginFunction;
    }(),
    authClient: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      oktaData = _useState2[0],
      setOktaData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      triggerLogin = _useState4[0],
      setTriggerLogin = _useState4[1];

  var tryLogin =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!triggerLogin) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return oktaData.loginFunction();

            case 3:
              setTriggerLogin(false);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function tryLogin() {
      return _ref3.apply(this, arguments);
    };
  }();

  var triggerLoginCall = (0, _react.useCallback)(function () {
    if (!triggerLogin) {
      setTriggerLogin(true);
    }
  }, [triggerLogin]);
  (0, _react.useEffect)(function () {
    tryLogin();
  }, [oktaData, triggerLogin]);
  (0, _react.useEffect)(function () {
    if (config) {
      var authClient = new _oktaAuthJs.OktaAuth({
        url: config.url,
        clientId: config.clientId,
        issuer: config.issuer,
        redirectUri: config.redirectUri,
        responseMode: "fragment",
        autoRenew: true
      });
      handleLogin(authClient, onLogin, onError);
      setOktaData({
        loginFunction: triggerLoginCall,
        authClient: authClient
      });
    }
  }, [config]);
  return oktaData;
};

exports.useOkta = useOkta;